import { render, staticRenderFns } from "./contentPricingCreate.vue?vue&type=template&id=7f87ef16&"
import script from "./contentPricingCreate.vue?vue&type=script&lang=js&"
export * from "./contentPricingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports